/* ==============================================================================================
 * [ACCESS] ADVANCED SEARCH RESULTS TABLE
 * ============================================================================================== */

var Sushi, CGS;

(function (Sushi, CGS) {
	"use strict";

	// TODO: Update API endpoint URLs
	var issuersApiEndpoint = "/json/access/issuerResults.json";
	var issuesApiEndpoint = "/json/access/issuerResultsIssues.json";

	var issuerTableElement = document.querySelector("#issuerResults");

	if (!issuerTableElement) {
		return;
	}

	var issuerTableColumns = [
		{
			data: "issuerNumber",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: "issuerName",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: "issuerSuspdtent",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: "issuerLinks",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: "issuerIssuesCount",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: null,
			orderable: false,
			className: "c-table__cell c-table__cell--expand",
			defaultContent: "",
		},
	];

	var issuerTableColumnDefs = [
		{
			targets: [0],
			render: function (data) {
				return "<a data-plugin='IssuerDetail' "
					+ "href='#' "
					+ "data-issuer-number='" + data + "' "
					+ ">" + data + "</a>";
			},
		},
		{
			targets: [1],
			render: function (data) {
				return CGS.setCellMinWidth(data, 300);
			},
		},
		{
			targets: [3],
			render: function (data) {
				if (data) {
					data = "<a data-plugin='AssociatedIssuer' href='#'>" + data + "</a>";
				}

				return data;
			},
		},
		{
			targets: [5],
			orderable: false,
		},
	];

	var getIssuesTable = function () {
		return CGS.createTableHtml({
			files: true,
			head: {
				rows: [{
					cells: [
						{ content: "" },
						{ content: "Issuer Number" },
						{ content: "Issue Number" },
						{ content: "Dated" },
						{ content: "Rate" },
						{ content: "Maturity" },
						{ content: "Description" },
						{ content: "Status" },
					],
				}],
			},
		});
	};

	var issuesTableColumns = [
		{
			data: null,
			orderable: false,
			className: "c-table__cell c-table__cell--checkbox",
		},
		{
			data: "issuerNumber",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: null,
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: "issueDatedDate",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: "issueRate",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: "issueMaturityDate",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: null,
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: "issueStatus",
			className: "c-table__cell",
			searchable: true,
		},
	];

	var issuesTableColumnDefs = [
		{
			targets: [0],
			render: function (data, type, row) {
				return CGS.renderFileExportCheckCell(
					row.issueDescription,
					Sushi.Util.uid()
				);
			},
		},
		{
			targets: [2],
			render: function (data) {
				data = "<a data-plugin='IssueDetail' "
					+ "href='#' "
					+ "data-issuer-number='" + data.issuerNumber + "' "
					+ "data-issue-number='" + data.issueNumber + "' "
					+ "data-issue-check='" + data.issueCheck + "'"
					+ ">" + data.issueNumber + " " + data.issueCheck + "</a>";

				return data;
			},
		},
		{
			targets: [5],
			render: function (data, type, row) {
				if (data !== "") {
					return data;
				}
				else if (row.issuePartialMaturity !== "") {
					return "00/00/" + row.issuePartialMaturity;
				}
				else {
					return "";
				}
			},
		},
		{
			targets: [6],
			render: function (data) {
				return CGS.setCellMinWidth(
					CGS.renderIssueDescriptionCell(data, false),
					300
				);
			},
		},
		{
			targets: [7],
			render: function (data) {
				switch (data) {
					case "S":
					case "Q":
					case "R":
						return "S";
					case "T":
					case "X":
						return data;
					default:
						return "";
				}
			},
		},
	];

	CGS.table(issuerTableElement, {
		ajax: issuersApiEndpoint,
		columns: issuerTableColumns,
		columnDefs: issuerTableColumnDefs,
		createdRow: function (row) {
			row.classList.add("c-table__row--expand");
		},
		initComplete: function (settings, json) {
			CGS.setupChildTables(settings, json, {
				ajax: {
					url: issuesApiEndpoint,
					dataSrc: "issueList",
				},
				columns: issuesTableColumns,
				columnDefs: issuesTableColumnDefs,
				tableFn: getIssuesTable,
			});
		},
	});

})(Sushi || (Sushi = {}), CGS || (CGS = {}));
